import { render, staticRenderFns } from "./BatchJJ.vue?vue&type=template&id=4c4c23bb&scoped=true&"
import script from "./BatchJJ.vue?vue&type=script&lang=js&"
export * from "./BatchJJ.vue?vue&type=script&lang=js&"
import style0 from "./BatchJJ.vue?vue&type=style&index=0&id=4c4c23bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c23bb",
  null
  
)

export default component.exports